import api from "../../../api";
export default {
  salesOrdersPut(params) {
    return api.put("sales-orders/" + params.url, params);
  },
  salesOrdersPost(params) {
    return api.post("sales-orders/" + params.url, params);
  },
  salesOrdersGet(params) {
    return api.get("sales-orders/" + params.url, { params: params });
  },
  salesOrdersDelete(params) {
    return api.delete("sales-orders/" + params.url, { params: params });
  },
  getSalesOrderApprovalSettings() {
    return api.get("sales-orders/salesOrderApprovalSettings");
  },
  storeSalesOrderApprovalBypass(params) {
    return api.post("sales-orders/salesOrderApprovalBypasses", params);
  },
  updateSalesOrderApprovalBypass(id, params) {
    return api.put(`sales-orders/salesOrderApprovalBypasses/${id}`, params);
  },
  destroySalesOrderApprovalBypass(id) {
    return api.delete(`sales-orders/salesOrderApprovalBypasses/${id}`);
  },
  storeSalesOrderApprovalApprover(params) {
    return api.post("sales-orders/salesOrderApprovalApprovers", params);
  },
  updateSalesOrderApprovalApprover(id, params) {
    return api.put(`sales-orders/salesOrderApprovalApprovers/${id}`, params);
  },
  destroySalesOrderApprovalApprover(id) {
    return api.delete(`sales-orders/salesOrderApprovalApprovers/${id}`);
  },
  canBypassSalesOrderApproval() {
    return api.get("sales-orders/canBypassSalesOrderApproval");
  },
  canApproveSalesOrders() {
    return api.get("sales-orders/canApproveSalesOrders");
  },
};
